export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const ADD_MENU_CATEGORIES = 'ADD_MENU_CATEGORIES';
export const ADD_MENU_PRODUCTS = 'ADD_MENU_PRODUCTS';
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_ADMIN_PRODUCTS = 'GET_ADMIN_PRODUCTS';
export const SELECT_ADMIN_PRODUCT = 'SELECT_ADMIN_PRODUCT';
